"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4231],{

/***/ 89010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WomenCategorySlider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46066);
// @ts-nocheck







function WomenCategorySlider(param) {
    var colletionData = param.colletionData, subCategoryRoute = param.subCategoryRoute;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var SampleNextArrow = function(props) {
        var onClick = props.onClick;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "slick-arrow slick-next",
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "6",
                height: "12",
                viewBox: "0 0 6 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5 1L1 6L5 11",
                    stroke: "#1E2432",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        });
    };
    var SamplePrevArrow = function(props) {
        var onClick = props.onClick;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "slick-arrow slick-prev",
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "6",
                height: "12",
                viewBox: "0 0 6 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M5 1L1 6L5 11",
                    stroke: "#1E2432",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            })
        });
    };
    var settings_Slider2 = {
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 8,
        slidesToScroll: 8,
        autoplay: false,
        variableWidth: true,
        autoplaySpeed: 10000,
        pauseOnHover: true,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SampleNextArrow, {}),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SamplePrevArrow, {}),
        responsive: [
            {
                breakpoint: 1440,
                speed: 1000,
                slidesToShow: 4,
                slidesToScroll: 4,
                settings: {
                    slidesToShow: 8.5,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 8.5,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 968,
                settings: {
                    slidesToShow: 4.5,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    infinite: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "category_slider",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, settings_Slider2), {
                children: colletionData === null || colletionData === void 0 ? void 0 : colletionData.map(function(childSubCategory, index) {
                    var ref, ref1;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/fashion/".concat(subCategoryRoute, "/").concat(childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.slug),
                            scroll: false,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "Category_slider_cover",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "catagory_block",
                                    style: {
                                        width: "fit-content",
                                        textAlign: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.id) === childSubCategory.slug ? "box_cover box_radius" : "box_cover",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.id) === childSubCategory.slug ? "box active" : "box",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "img_cover",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.media,
                                                        alt: "Category_slider_cover_img"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.name
                                        })
                                    ]
                                })
                            })
                        })
                    }, index);
                })
            }))
        })
    });
}


/***/ }),

/***/ 94231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WomenCategorySelectSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/store/store.tsx + 6 modules
var store = __webpack_require__(74573);
// EXTERNAL MODULE: ./src/store/slices/manageApplianceCategorySlice.tsx + 2 modules
var manageApplianceCategorySlice = __webpack_require__(18829);
// EXTERNAL MODULE: ./public/assets/icon/search-close.svg
var search_close = __webpack_require__(18760);
// EXTERNAL MODULE: ./src/components/ProductPage/TabProduct/ProductListView.tsx + 1 modules
var ProductListView = __webpack_require__(89681);
// EXTERNAL MODULE: ./src/components/ProductPage/AllProduct/index.tsx + 2 modules
var AllProduct = __webpack_require__(55317);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/WomenCategorySelectSection/WomenCategoryMobileModal/index.tsx









function WomenCategoryMobileModal(param) {
    var fetchUpdatedProduct = param.fetchUpdatedProduct, setPage = param.setPage, page = param.page, dataLimite = param.dataLimite, subCategoryRoute = param.subCategoryRoute, category = param.category, subCategory = param.subCategory, childSubCategory = param.childSubCategory;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,store/* useAppDispatch */.T)();
    var productByCategory = (0,es/* useSelector */.v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.productByCategory;
    });
    var manageApplianceCategoryModal = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageApplianceCategoryModal) === null || ref === void 0 ? void 0 : ref.data;
    });
    var ref10 = (0,react.useState)({
        subCategory: [],
        category: []
    }), filterData = ref10[0], setFilterData = ref10[1];
    var categoryData = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.fetchCategory) === null || ref === void 0 ? void 0 : ref.categoryData;
    });
    var ref11 = (0,react.useState)(0), lastScrollTop = ref11[0], setLastScrollTop = ref11[1];
    var ref12 = (0,react.useState)("noScroll"), scrollDirection = ref12[0], setScrollDirection = ref12[1];
    // useEffect(() => {
    //   setPage(1)
    //   dispatch(
    //     fetchProductByCategory({
    //       category: 'Fashion & Accessories',
    //       subCategory: router?.asPath?.includes('women') ? 'Women' : 'Men',
    //       childSubCategory: router?.query?.id ? router?.query?.id : '',
    //       isShopifyProduct: false,
    //       page: page,
    //       limit: dataLimite,
    //     }),
    //   )
    // }, [])
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (currentScrollTop === 0) {
                setScrollDirection("noScroll");
            } else if (currentScrollTop > lastScrollTop) {
                setScrollDirection("topToDownsc");
            } else {
                setScrollDirection("downToTopsc");
            }
            setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        lastScrollTop
    ]);
    var ref13 = (0,react.useState)(false), MenMobileviewSidebar = ref13[0], setMenMobileviewSidebar = ref13[1];
    var ref14 = (0,react.useState)("grid"), view = ref14[0], setView = ref14[1];
    var ref15 = (0,react.useState)(false), SerchDetails = ref15[0], setSerchDetails = ref15[1];
    // if (loading) return <Loader />
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mobileSubCategory-back-alignment",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "back_details-alignment",
                        onClick: function() {
                            return router.push("/fashion/women");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/assets/icon/left-icon.svg",
                                    alt: "back-page"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Woma..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile-heading-alignment",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            children: "Shop by Cate..."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "women-mobile-view-details-fashion-name-search-alignment",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-women-width-alignment",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mobile-view-sidebar-alignment",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mobile-search-sidebar-details-box-alignment",
                                children: MenMobileviewSidebar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mobile-view-sidebar-box-alignment",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mobile-silder-side-main-details",
                                        children: categoryData === null || categoryData === void 0 ? void 0 : categoryData.map(function(childSubCategory, index) {
                                            var ref;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/fashion/women/".concat(childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.slug)
                                                    },
                                                    scroll: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mobile-slider-all-details-alignment ",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "mobile-silder-main-box-alignmrnt ".concat((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.id) === (childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.slug) && "active-women-category"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "mobile-slider-details-img",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.media,
                                                                        alt: "Frame1"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "category-name-align",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: childSubCategory === null || childSubCategory === void 0 ? void 0 : childSubCategory.name
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "header-width-alignment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "right-side-alignment",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "\n                    headerDesign\n                    ".concat(scrollDirection === "topToDownsc" ? "topToDownsc" : scrollDirection === "downToTopsc" ? "downToTopsc" : "", "\n                  "),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: MenMobileviewSidebar ? "mobile-view-child-heading-alignment open-sidebar-header-change" : "mobile-view-child-heading-alignment",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mobile-view-right-side-alignment",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                // className="mobile-view-close-arrow-alignment"
                                                                className: "mobile-view-close-arrow-alignment ".concat(MenMobileviewSidebar ? "d-none" : "d-block"),
                                                                onClick: function() {
                                                                    setMenMobileviewSidebar(!MenMobileviewSidebar);
                                                                    setSerchDetails(false);
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/assets/icon/left-icon.svg",
                                                                    className: "rotate",
                                                                    alt: "back-page"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "mobile-view-child-name-alignment",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        children: manageApplianceCategoryModal === null || manageApplianceCategoryModal === void 0 ? void 0 : (ref = manageApplianceCategoryModal.id) === null || ref === void 0 ? void 0 : ref.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            "(",
                                                                            (productByCategory === null || productByCategory === void 0 ? void 0 : (ref1 = productByCategory.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getAllProducts) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.length) || 0,
                                                                            " item)"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mobile-view-list-alignment",
                                                        children: !MenMobileviewSidebar && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "mobile-view-list-alignment",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    onClick: function() {
                                                                        return setView("grid");
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                        width: "24",
                                                                        height: "24",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "3",
                                                                                y: "3",
                                                                                width: "7.33333",
                                                                                height: "6",
                                                                                rx: "1.66667",
                                                                                stroke: view === "grid" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "13.6719",
                                                                                y: "3",
                                                                                width: "7.33333",
                                                                                height: "8.66667",
                                                                                rx: "1.66667",
                                                                                stroke: view === "grid" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "3",
                                                                                y: "12.3281",
                                                                                width: "7.33333",
                                                                                height: "8.66667",
                                                                                rx: "1.66667",
                                                                                stroke: view === "grid" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "13.6719",
                                                                                y: "15",
                                                                                width: "7.33333",
                                                                                height: "6",
                                                                                rx: "1.66667",
                                                                                stroke: view === "grid" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    onClick: function() {
                                                                        return setView("list");
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                        width: "24",
                                                                        height: "24",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "3",
                                                                                y: "3",
                                                                                width: "4",
                                                                                height: "4",
                                                                                rx: "1.66667",
                                                                                stroke: view === "list" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "11",
                                                                                y: "3",
                                                                                width: "10",
                                                                                height: "4",
                                                                                rx: "1.66667",
                                                                                stroke: view === "list" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "3",
                                                                                y: "10",
                                                                                width: "4",
                                                                                height: "4",
                                                                                rx: "1.66667",
                                                                                stroke: view === "list" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "3",
                                                                                y: "17",
                                                                                width: "4",
                                                                                height: "4",
                                                                                rx: "1.66667",
                                                                                stroke: view === "list" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "11",
                                                                                y: "10",
                                                                                width: "10",
                                                                                height: "4",
                                                                                rx: "1.66667",
                                                                                stroke: view === "list" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                                                x: "11",
                                                                                y: "17",
                                                                                width: "10",
                                                                                height: "4",
                                                                                rx: "1.66667",
                                                                                stroke: view === "list" ? "#A855F7" : "#ACB1C0",
                                                                                strokeWidth: "2"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        SerchDetails && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mobile-child-search-alignment",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "close-alignment",
                                                    onClick: function() {
                                                        return setSerchDetails(false);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: search_close/* default.src */.Z.src,
                                                        alt: "CloseIcon"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: view === "grid" ? "women-mobile-findYourStyle_product_block mobile-contain" : "women-mobile-findYourStyle_product_block",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "",
                                                        children: view === "grid" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AllProduct/* default */.Z, {
                                                            products: productByCategory === null || productByCategory === void 0 ? void 0 : (ref4 = productByCategory.product) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.getAllProducts) === null || ref5 === void 0 ? void 0 : ref5.data,
                                                            storeId: 0,
                                                            color: "#FFFFFF",
                                                            total: productByCategory === null || productByCategory === void 0 ? void 0 : (ref6 = productByCategory.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.getAllProducts) === null || ref7 === void 0 ? void 0 : ref7.total,
                                                            dataLimite: dataLimite,
                                                            setPage: setPage,
                                                            page: page,
                                                            topForFilter: 66,
                                                            isFilterMenu: true,
                                                            mobileTopForFilter: -1,
                                                            isPadding: true,
                                                            isCalled: productByCategory === null || productByCategory === void 0 ? void 0 : productByCategory.called,
                                                            setFilterData: setFilterData,
                                                            filterData: filterData,
                                                            APIcall: fetchUpdatedProduct,
                                                            category_slug: category,
                                                            subCategory_slug: subCategory,
                                                            childSubCategory_slug: childSubCategory
                                                        })
                                                    }),
                                                    view === "list" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListView/* default */.Z, {
                                                        products: productByCategory === null || productByCategory === void 0 ? void 0 : (ref8 = productByCategory.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.getAllProducts) === null || ref9 === void 0 ? void 0 : ref9.data,
                                                        color: "#FFFFFF",
                                                        stateForWidth: MenMobileviewSidebar
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/WomenCategorySelectSection/WomenCategorySlider/index.tsx
var WomenCategorySlider = __webpack_require__(89010);
;// CONCATENATED MODULE: ./src/components/Category/MainCategory/WomenCategory/WomanPageModal/WomenCategorySelectSection/index.tsx







function WomenCategorySelectSection(param) {
    var colletionData = param.colletionData, fetchUpdatedProduct = param.fetchUpdatedProduct, setPage = param.setPage, page = param.page, dataLimite = param.dataLimite, subCategoryRoute = param.subCategoryRoute, category = param.category, subCategory = param.subCategory, childSubCategory = param.childSubCategory;
    var ref;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var router = (0,next_router.useRouter)();
    var filterData = colletionData === null || colletionData === void 0 ? void 0 : colletionData.find(function(cat) {
        var ref;
        return (cat === null || cat === void 0 ? void 0 : cat.slug) === (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.id);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "category-by-shoes-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row section_3_row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "left_block category-by-shoes-heading-left-arrow-alignment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "left_cover",
                                    onClick: function() {
                                        router.push("/fashion/women/", undefined, {
                                            scroll: false
                                        });
                                        dispatch((0,manageApplianceCategorySlice/* fetchApplianceCategory */.O)({
                                            modal: "",
                                            isOpen: false,
                                            id: 0
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/assets/icon/leftArrow.svg",
                                        alt: "left-arrow"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "right_block category-by-shoes-heading-right-alignment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "right_block_cover",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenCategorySlider/* default */.Z, {
                                        colletionData: colletionData,
                                        subCategoryRoute: subCategoryRoute
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.id) !== "accessories" && /*#__PURE__*/ (0,jsx_runtime.jsx)(WomenCategoryMobileModal, {
                fetchUpdatedProduct: fetchUpdatedProduct,
                setPage: setPage,
                page: page,
                dataLimite: dataLimite,
                category: category,
                subCategory: subCategory,
                childSubCategory: childSubCategory
            })
        ]
    });
}


/***/ })

}]);